import { PageHead } from "@generalapplications/html-render/react";
import { useParams } from "react-router-dom";

import { IndustryTemplate } from "@/app/pages/industryDetail/components/IndustryTemplate";
import { getIndustryBySlug } from "@/content/industries";
import { routes } from "@/app/common/functions/routes/routes";
import { pageHead, sectionTrail } from "@/app/common/functions/seo/pageHead";

import { NotFoundPage } from "@/app/pages/notFound/NotFoundPage";

export function IndustryDetailPage() {
  const { slug } = useParams<{ slug: string }>();
  const industry = slug ? getIndustryBySlug(slug) : undefined;

  if (!industry) {
    return <NotFoundPage />;
  }

  const path = routes.industries.detail(industry.slug);
  return (
    <>
      <PageHead
        head={pageHead({
          path,
          title: industry.seoTitle,
          description: industry.seoDescription,
          imagePath: industry.image,
          breadcrumbs: sectionTrail(
            { name: "Industries", path: routes.industries.index },
            { name: industry.title, path },
          ),
        })}
      />
      <IndustryTemplate industry={industry} />
    </>
  );
}
